<template>

<div 
    class="field" 
    :class="{
        'is-condensed': isCondensed,
        'is-sticky': isSticky
    }"
	:sortIndex="(sortingCount > 1 || sort !== 'name' || isSortedReverse) ? isSorted : 0" 
    :data-align="align"
>

    <slot></slot>

</div>

</template>

<script>

import $field from '@/field'

export default {

    props: ['align', 'isCondensed', 'isSticky', 'field', 'filter'],

	computed: {

		sortingCount: function() {
		
			return this.$util.sortcount((this.filter) ? this.$store.getters['filter/' + this.filter] : false)

		},

		sort: function() {

			return $field.type[this.field.type].sort

		},

		isSorted: function() {

			return this.$util.sorted(this.sort, (this.filter) ? this.$store.getters['filter/' + this.filter] : false) 

		},

		isSortedReverse: function() {

			return this.$util.sorted(this.sort, (this.filter) ? this.$store.getters['filter/' + this.filter] : false, true) 

		}

	}

}

</script>

<style scoped>

.field {
    padding: 0px 5px;
    min-height: 40px;
	color: #333;
	font-weight: 400;
	font-size: 14px;
	line-height: 14px;
    border-right: 1px solid #eee;
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.is-mobile .field {
    font-size: 12px;
    line-height: 12px;
}

.field.is-sticky {
    opacity: 0;
    pointer-events: none;
}

.field[data-align="center"] {
    width: 100%;
    text-align: center;
    align-items: center;
}

</style>